export const QUICKBOOKS_CLOSE_IFRAME_MESSAGE_TYPE = 'easyllama.quickbooks.close'

export function closeQuickbooksIframe(url) {
  window.parent.postMessage({ type: QUICKBOOKS_CLOSE_IFRAME_MESSAGE_TYPE, url }, '*')
}
